import * as navigation from 'Navigation';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';

export default class StorableResultsTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: MODEL_NAMES.Results,
      closeable: false,
      preferenceKey: 'storable-results',
    };
  }
}
